// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contact-banner[data-v-0ff5793e]{background-color:#e3e7ec;height:4.8em;display:flex;align-items:center;justify-content:center;text-align:center;text-transform:uppercase}.contact-container[data-v-0ff5793e]{max-width:800px}.row>div[data-v-0ff5793e]{padding-top:0;padding-bottom:5px}address[data-v-0ff5793e]{font-style:normal}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
